import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import PersonIcon from "@mui/icons-material/Person";
import { CircularProgress, Fab, Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { UserContext } from "../../../../../App";
import CashDrawerModal from "../../../product/all-products/components/CashDrawerModal/CashDrawerModal";
import { getBarcodeStat } from "./../../../product/all-products/redux/Reducers/paginationReducer";
import "./index.css";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { openProductDetailsSearch } from "../../../product/all-products/redux/Actions/paginationActions";
import { useDispatch } from "react-redux";

export const CartTableBar = () => {
  const [drawerModal, setDrawerModal] = useState(false);
  const customerMobile = JSON.parse(localStorage.getItem("customer_details"))?.mobileNumber;
  const customerName = JSON.parse(localStorage.getItem("customer_details"))?.name;
  const loyaltyDetails = JSON.parse(localStorage.getItem("loyaltyDetails"));
  const barcodeLoading = useSelector(getBarcodeStat);
  const { cartItems, cartTotalQty, color } = useContext(UserContext);
  const dispatch = useDispatch();

  const fabGreenStyle = {
    color: "#0562FB",
    border: "3px solid #0562FB !important",
    backgroundColor: color === "dark" ? "rgb(53,58,80)" : "rgb(255,255,255)",
    height: "37px !important",
    boxShadow: "none",
    "&:hover": {
      color: "white",
      backgroundColor: "#0562FB",
    },
  };

  return (
    <>
      <div className="OrderItemTextContainer-keyboard">
        <div style={{ display: "flex" }} className="order-top-container">
          <p>Cart</p>
          <h4 className="new-two-way-text">Items : {cartItems?.length || 0}</h4>
          <h4 className="new-two-way-text">Quantity : {cartTotalQty || 0}</h4>
          {loyaltyDetails && (
            <h4 className="new-two-way-text">
              Loyalty Balance :{" "}
              {`${loyaltyDetails.totalLoyalty} (₹${loyaltyDetails.totalLoyaltyValue})` || 0}
            </h4>
          )}
          {barcodeLoading ? (
            <CircularProgress
              size="1.5rem"
              style={{
                marginLeft: "10px",
                marginRight: "10px",
                fontWeight: "bold",
                verticalAlign: "middle",
              }}
            />
          ) : null}
        </div>
        <div className="cart-table-bar">
          <div className="number-container">
            <PersonIcon className="number-icon" fontSize="medium" />
            <div className="number-text">
              {customerName ? `${customerName}-` : ""}
              {customerMobile || `No Customer`}{" "}
            </div>{" "}
          </div>
          <div>
            <div className="cart-table-product-details">
              <IconButton
                onClick={() => setDrawerModal(true)}
                className="editicon"
                aria-label="Example"
              >
                <CurrencyExchangeIcon />
              </IconButton>
              <Box>
                <Fab
                  aria-label="add"
                  variant="extended"
                  sx={{ ...fabGreenStyle }}
                  onClick={() => dispatch(openProductDetailsSearch(true))}
                >
                  <ManageSearchIcon />
                  <b>(Atl + 6)</b>
                </Fab>
              </Box>
            </div>
            <Modal
              open={drawerModal}
              onClose={() => setDrawerModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <CashDrawerModal setDrawerModal={setDrawerModal} />
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};
